import { render, staticRenderFns } from "./footnote.vue?vue&type=template&id=0ab8b944&"
import script from "./footnote.vue?vue&type=script&lang=js&"
export * from "./footnote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports